const START_DRAG = Symbol('START_DRAG')
const DRAG = Symbol('DRAG')
const END_DRAG = Symbol('END_DRAG')
const SET_DROP_TARGET = Symbol('SET_DROP_TARGET')
const EXPAND_ALL_LAYERS = Symbol('EXPAND_ALL_LAYERS')
const COLLAPSE_ALL_LAYERS = Symbol('COLLAPSE_ALL_LAYERS')
const RESET_GLOBAL_EXPANSION = Symbol('RESET_GLOBAL_EXPANSION')

const INITIAL_STATE = {
  dragging: false,
  dropTarget: null,
  options: {},
  objects: [],
  offset: null,
  position: null,
  globalExpansionState: null,
}

export default (state = INITIAL_STATE, action) => {
  if (action.type === START_DRAG) {
    const { objects, offset, position } = action

    return {
      ...state,
      objects,
      offset,
      position,
      dragging: true,
    }
  }

  if (action.type === DRAG) {
    const { position } = action

    return {
      ...state,
      position,
    }
  }

  if (action.type === END_DRAG) {
    return INITIAL_STATE
  }

  if (action.type === SET_DROP_TARGET) {
    const { dropTarget, options } = action

    return {
      ...state,
      dropTarget,
      options,
    }
  }

  if (action.type === EXPAND_ALL_LAYERS) {
    return {
      ...state,
      globalExpansionState: 'expanded',
    }
  }

  if (action.type === COLLAPSE_ALL_LAYERS) {
    return {
      ...state,
      globalExpansionState: 'collapsed',
    }
  }

  if (action.type === RESET_GLOBAL_EXPANSION) {
    return {
      ...state,
      globalExpansionState: null,
    }
  }

  return state
}

// ACTIONS

export const startDrag = (objects, offset, position) => ({
  type: START_DRAG,
  objects,
  offset,
  position,
})

export const drag = position => ({
  type: DRAG,
  position,
})

export const endDrag = () => ({ type: END_DRAG })

export const setDropTarget = (dropTarget, options) => ({
  type: SET_DROP_TARGET,
  dropTarget,
  options,
})

export const expandAllLayers = () => ({
  type: EXPAND_ALL_LAYERS,
})

export const collapseAllLayers = () => ({
  type: COLLAPSE_ALL_LAYERS,
})

export const resetGlobalExpansion = () => ({
  type: RESET_GLOBAL_EXPANSION,
})

// SELECTORS

export const getLayers = state => state.editor.layers

export const getGlobalExpansionState = state =>
  state.editor.layers.globalExpansionState
